// import { Kennzahl, getKennzahl } from './Kennzahl';
// import { KennzahlFaktor } from './KennzahlFaktor';
import { setKennzahlObj } from '../strukturiert/KennzahlTools';

// let keynum = 0;

export function makeSimpleKennzahl(
    bereich: string, key: string, jahr: number, standort_tid: any, tid: any, name_menge: string, name_item: string, menge: number,
    co2_value: number, einheit: string, faktor_wert: number, faktor_quelle: string, data: any, faktor_einheit?: string,
    faktor_um?: number, faktor_um_einheit?: string
) {
    // keynum++;
    const row: any = { menge, jahr, tid };
    if (standort_tid) {
        const keyCompare: string = (key || '').toString();
        key = keyCompare.length && keyCompare.substring(0, 4) === 'ss3_' && keyCompare.substring(3, 7) !== '_fzg'
            ? `ss3_${name_item}` : key;
        setKennzahlObj({
            standort_tid,
            data,
            kennName: `${name_menge} ${name_item}`,
            bereich,
            key,
            field: 'menge',
            item: row,
            einheit
        });
        if (faktor_wert) {
            setKennzahlObj({
                standort_tid,
                data,
                kennName: `CO₂-Emission ${name_item}`,
                bereich,
                key: `${key}_co2`,
                field: 'menge',
                item: row,
                einheit: 'tCO₂Äq',
                einheitOrig: einheit,
                faktor_um,
                faktor_um_einheit,
                faktor_co2: faktor_wert,
                faktor_co2_einheit: faktor_einheit,
                faktor_co2_quelle: faktor_quelle
            });
        }
    }
    // const kennzahl: Kennzahl = getKennzahl(key, 'menge', jahr, standort_tid + '', data);
    // if (kennzahl.isInitialized()) {
    //     return;
    // }
    // if (!kennzahl.isInitialized()) {
    //     kennzahl
    //         .setType(Kennzahl.TYPE_SUMME)
    //         .setBereich(bereich)
    //         .setName(`${name_menge} ${name_item}`)
    //         .setEinheit(einheit);
    // }
    // const kennzahlItem: Kennzahl = kennzahl.addValue(menge, tid);
    // kennzahlItem
    //     .setType(Kennzahl.TYPE_EINGABE)
    //     .setInfo(name_item)
    //     .setEinheit(einheit)
    //     .setValue(menge);
    // const kennzahlCo2: Kennzahl = getKennzahl(key, 'co2', jahr, standort_tid + '', data);
    // if (!kennzahlCo2.isInitialized()) {
    //     kennzahlCo2
    //         .setType(Kennzahl.TYPE_SUMME)
    //         .setBereich(bereich)
    //         .setName(`CO₂-Emission ${name_item}`)
    //         .setEinheit('t');
    // }
    // const kennzahlCo2Item: Kennzahl = kennzahlCo2.addValue(co2_value, tid);
    // kennzahlCo2Item
    //     .setType(Kennzahl.TYPE_BERECHNUNG)
    //     .setInfo(name_item)
    //     .addItem(kennzahlItem)
    //     .addFaktor(faktor_wert, KennzahlFaktor.TYPE_CO2, faktor_quelle, 'CO₂-Faktor', data, faktor_einheit)
    //     .setFormel(faktor_mengenumrechnung ? 'umrechnung_co2' : 'co2_emission');
    // if (faktor_mengenumrechnung) {
    //     kennzahlCo2Item.addFaktor(faktor_mengenumrechnung, KennzahlFaktor.TYPE_UMRECHNUNG, null, 'Umrechnung ' + einheit_mengenumrechnung, data);
    // }
    // const kennzahl: Kennzahl = getKennzahl(key, 'menge', jahr, standort_tid + '', data);
    // if (!kennzahl.isInitialized()) {
    //     kennzahl
    //     .setBereich(bereich)
    //     .setType(Kennzahl.TYPE_EINGABE)
    //     .setName(name_menge + ' ' + name_item)
    //     .setValue(menge)
    //     .setEinheit(einheit);
    // }
    // const kennzahlCo2Item: Kennzahl = getKennzahl(key, 'co2', jahr, standort_tid + '', data);
    // if (!kennzahlCo2Item.isInitialized()) {
    //     kennzahlCo2Item
    //     .setType(Kennzahl.TYPE_BERECHNUNG)
    //     .setBereich(bereich)
    //     .setName('CO₂-Emission ' + name_item)
    //     .addItem(kennzahl)
    //     .setEinheit('t')
    //     .addFaktor(faktor_wert, KennzahlFaktor.TYPE_CO2, faktor_quelle, 'CO₂-Faktor')
    //     .setFormel('co2_emission')
    //     .setValue(co2_value);
    // }

    // Noch brauchen wir das nirgends ....
    // return kennzahlCo2Item;
}
